import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllCarouselsTable from './Table';
import NewCarouselModal from '../../Modals/Carousel/NewCarouselModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllCarouselsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            carousels: [],
            carouselQueryObject: {
                sort: 'context,context_order,title,id',
                limit: 9999,
            },
        };
    }
    componentDidMount() {
        this.loadCarousels();
    }
    onColumnSort = ( value ) => {
        if( this.state.carouselQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.carousels = [];
            prevState.carouselQueryObject.sort = value;
            return prevState;
        } );
        this.loadCarousels();
    }
    loadCarousels = () => {
        return this.props.getCarousels( this.state.carouselQueryObject )
        .then( ( carousels ) => {
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.carousels = prevState.carousels.concat( carousels );
                return prevState;
            } );
            return carousels;
        } );
    }
    carouselUpdated = () => {
        this.setState( {
            fetching: true,
            carousels: [],
        }, () => {
            this.loadCarousels();
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }
    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }
    onNewModalSubmit = ( newCarousel ) => {
        this.setState( ( altState ) => {
            altState.carousels.unshift( newCarousel );
            altState.carousels = altState.carousels.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    render() {
        const { fetching, carousels } = this.state;

        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>Carousels</h2>
                    <div className={ style.controls }>
                        <PrimaryButton
                        label='+ Create Carousel'
                        style={ { width: '150px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/carousels' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allCarousel }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllCarouselsTable
                            carousels={ carousels }
                            currentSort={ this.state.carouselQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onCarouselUpdated={ this.carouselUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewCarouselModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit }/>
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getCarousels: ( queryObject ) => {
            return dAPI.get( '/admin/curated-carousels', queryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllCarouselsView );
